<template>
  <v-container fluid>
    <v-row>
      <v-col cols="8" align="start" class="start text size-large weight-bold font-alt pa-4">Les segments</v-col>
      <v-col cols="4" align="end">
        <v-btn class="theme-btn shape-rounded filled-purple glow drawer-button" @click="createSegment()">
          Créer un segment
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <segments-table />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import SegmentsTable from './components/segments-table.vue'

export default {
  components: {
    SegmentsTable
  },
  methods: {
    createSegment() {
      this.$router
        .push({
          name: 'CreateSegment'
        })
        .catch(() => { });
    }
  }
}
</script>